import request from '@/utils/request'

const _Prefix = "/wechat/auditRecord"

// 查询审核信息列表
export function auditRecordList(query) {
    return request({
        url: _Prefix + '/list',
        method: 'get',
        params: query
    })
}


// 查询审核信息详细
export function auditingDetail(id) {
    return request({
        url: _Prefix + '/' + id,        
        method: 'get'
    })
}

// 修改审核状态
export function editAuditRecord(data) {
    return request({
        url: '/wechat/auditRecord/edit',        
        method: 'put',
        data: data,
    })
}

//房源详情
export function houseInfo(id) {
    return request({
        url: `/houseInfo/${id}`,
        method: 'get'
    })
}

//客源详情
export function lesseeInfo(id) {
    return request({
        url: `/lesseeInfo/${id}`,
        method: 'get'
    })
}

//合同详情
export function contractsInfo(id) {
    return request({
        url: `/contractsInfo/${id}`,
        method: 'get'
    })
}

/* // 新增审核信息
export function addAuditRecord(data) {
    return request({
        url: _Prefix,
        method: 'post',
        data: data
    })
}

// 修改审核信息
export function updateAuditRecord(data) {
    return request({
        url: _Prefix,
        method: 'put',
        data: data
    })
}

// 删除审核信息
export function delAuditRecord(ids) {
    return request({
        url: _Prefix + '/' + ids,
        method: 'delete'
    })
} */